import * as THREE from "three";

export function getZSphericalCoordinates(r, theta, phi) {
  return r * Math.cos(THREE.MathUtils.degToRad(phi));
}

export function toPositiveAngle(radAngle) {
  const twoPi = 2 * Math.PI;
  return (radAngle % twoPi + twoPi) % twoPi;
}

export function getYSphericalCoordinates(r, theta, phi) {
  return r * Math.sin(THREE.MathUtils.degToRad(theta)) * Math.sin(THREE.MathUtils.degToRad(phi));
}

export function getXSphericalCoordinates(r, theta, phi) {
  return r * Math.cos(THREE.MathUtils.degToRad(theta)) * Math.sin(THREE.MathUtils.degToRad(phi));
}


//calc linear interpolation in 3d axis
export function getLICoordinates(vector1, vector2, t) {
  return new THREE.Vector3(
    vector1.getComponent(0) + (t * (vector2.getComponent(0) - vector1.getComponent(0))),
    vector1.getComponent(1) + (t * (vector2.getComponent(1) - vector1.getComponent(1))),
    vector1.getComponent(2) + (t * (vector2.getComponent(2) - vector1.getComponent(2))),
  );
}

export function roundAngleToDirection(angleRad) {
  // Normaliza o ângulo para estar entre 0 e 2π
  const fullCircle = 2 * Math.PI;
  angleRad = angleRad % fullCircle;
  if (angleRad < 0) angleRad += fullCircle;

  // Arredonda o ângulo para o múltiplo mais próximo de π/2
  let radDirection = Math.round(angleRad / (Math.PI / 2)) * (Math.PI / 2);

  // Normaliza para estar entre 0 e 2π (caso o arredondamento dê 2π)
  if (radDirection === fullCircle) radDirection = 0;

  return radDirection;
}

export function calculateAngleBetweenLines(point, endLineOne, endLineTwo) {
  const vector1 = new THREE.Vector2().subVectors(endLineOne, point);
  const vector2 = new THREE.Vector2().subVectors(endLineTwo, point);

  const scaleProduct = vector1.dot(vector2);

  const magVec1 = vector1.length();
  const magVec2 = vector2.length();

  const cosTheta = scaleProduct / (magVec1 * magVec2);
  const radAngle = Math.acos(cosTheta);

  const degAngle = THREE.MathUtils.radToDeg(radAngle);

  return { degAngle, radAngle };
}

